<template>
  <base-svg-icon :name="name" />
</template>
<script setup>
import { onBeforeMount } from 'vue'
import BaseSvgIcon from '@emcd-shared/base-svg-icon'

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
})

onBeforeMount(() => import(`@/app/assets/icons/SVG/${props.name}.svg`))
</script>
